{
  "pt": {
    "locale_field": {
      "fallback_tooltip": "Quando nenhum texto for inserido para esta língua, este texto padrão será usado como substituto.",
      "fill_missing": "Preencher idioma em falta ({count}) | Preencher idiomas em falta ({count})",
      "fill_missing_budget_used": "O orçamento de IA deste mês foi esgotado.",
      "fill_missing_done": "Idiomas em falta preenchidos. Verifique o texto antes de guardar.",
      "fill_missing_errors": {
        "budget_reached": "O orçamento de IA deste mês foi esgotado. Contacte a Ziggu para o aumentar.",
        "generic": "Não foi possível preencher os idiomas. Tente novamente.",
        "too_long": "Este texto é demasiado longo para traduzir de uma só vez."
      },
      "fill_missing_tooltip": "Traduz a partir de {language} com IA. Verifique o texto antes de guardar.",
      "translated_in": "Traduzido em"
    }
  }
}
